export default "__VITE_ASSET__CEVvKzl2__"